<template>
  <div class="tile-layout">
    <div class="intro">Rotate your tiles and see how the pattern looks like when there joined.</div>

    <div class="image-container" ref="image">
      <div class="row">
        <div class="col-sm-3 tile" v-for="n in 16" :key="n" ref="images">
          <img class="image" :src="colorImage" @load="loadCount++" :style="layoutStyles[n]">

          <div :id="'tools' + n" class="tools">
            <button class="rotate btn" @click="changeStyle('rotate', n)"></button>
            <button class="flip-h btn" @click="changeStyle('flipH', n)"></button>
            <button class="flip-v btn" @click="changeStyle('flipV', n)"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'TileLayout',
    data: function(){

        return {
            loadCount: 0
        }

    },
    computed: {
        colorImage() {
            return this.$store.state.colorImage;
        },
        layoutStyles(){
            return this.$store.state.layoutStyles;
        },
        generateImage(){
            return [this.loadCount, this.layoutStyles];
        }
    },
    watch:{
        generateImage(){
            if(this.loadCount >= this.$refs.images.length){
                let vm = this,
                    noTools = function(node){
                      return (node.id.indexOf('tools') === -1);
                    };

                vm.$nextTick(function(){

                    setTimeout(function(){ // wait till animation is finished

                        vm.$domtoimage.toSvg(vm.$refs.image, {filter: noTools})
                            .then(function(dataUrl){
                                vm.$store.commit('setLayoutImage', dataUrl);
                                vm.$emit('ready', true);
                            });

                    }, 400)
                })
            }
        }
    },
    methods: {
        addStyle(style){
            let css = {
                '-ms-transform': 'rotate(' + style.angle + 'deg) scale(' + style.hf + ',' + style.vf + ')',
                '-webkit-transform' : 'rotate(' + style.angle + 'deg) scale(' + style.hf + ',' + style.vf + ')',
                'transform': 'rotate(' + style.angle + 'deg) scale(' + style.hf + ',' + style.vf + ')'
            };

            this.$store.dispatch('addStyle', Object.assign({}, style, css));

        },
        changeStyle(method, n){

            let style = this.layoutStyles[n] || {id: n, angle: 0, hf: 1, vf: 1};

            this[method](style);

            this.addStyle(style);

        },
        rotate(style){

            style.angle += 90;

            if(style.angle == 360){
                style.angle = 0;
            }

        },

        flipH(style){

            if(style.angle == 90 || style.angle == 270){
                style.vf = -1 * style.vf;
            }else{
                style.hf = -1 * style.hf;
            }


        },

        flipV(style){

            if(style.angle == 90 || style.angle == 270){
                style.hf = -1 * style.hf;
            }else{
                style.vf = -1 * style.vf;
            }

        }


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .intro{
    text-align: center;
    padding-bottom: 15px;
  }

  .tile-layout {
    clear: both;
  }

  .image-container > .row{
    margin: -2px;

    & > div{
      padding: 2px;
    }
  }

  .tile{
    .image{
      display: block;
      width: 100%;
      transition: all 0.3s ease;
    }

  }

  .tools{
    position: absolute;
    top: 50%;
    margin-top: -17.5px;
    left: 50%;
    margin-left: -57px;
    padding: 5px 8px;
    opacity: 0;
    transition: opacity 0.3s ease;
    background-color: rgba(0,0,0,0.5);
    border-radius: 5px;

    button{
      width: 25px;
      height: 25px;
      background-size: 70%;
      background-position: 4px center;
      outline: none !important;
      background-repeat: no-repeat;
      background-color: #fff;
      transition: all 0.2s ease;

      &:not(:first-child){
        margin-left: 10px;
      }

      &:hover{
        transform: scale(1.1);
      }
    }

  }

  .rotate{
    background-image: url('../assets/rotate.png') !important;
  }

  .flip-h{
    background-image: url('../assets/h-flip.png') !important;
  }

  .flip-v{
    background-image: url('../assets/v-flip.png') !important;
  }

  .image:hover + .tools, .tools:hover{
    opacity: 1;
  }
</style>
